export const DISPLAY_TYPE = {
  CONTRIBUTORS: 'contributors',
  DETRACTORS: 'detractors',
} as const;

export const Constants = {
  TAG_NAME: 'pop-contributors-detractors-component',
  COMPONENT_TITLE: 'Top contributors and detractors',
  COMPONENT_UNAVAILABLE: 'Top contributors and detractors unavailable',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'data-as-of-select',
  PERIOD_DROPDOWN_LABEL: 'View',
  PERIOD_DROPDOWN_ID: 'period-select',
  PERIOD_NO_DROPDOWN_PREFIX_LABEL: 'Showing',
  PERIOD_NO_DROPDOWN_SUFFIX_LABEL: 'top contributors and detractors',
  CONTRIBUTORS_TAB_LABEL: 'Contributors',
  DETRACTORS_TAB_LABEL: 'Detractors',
  DEFAULT_PERIOD: '1 Year',
  CONTRIBUTORS_NO_DATA_MESSAGE: 'Top 10 contributors unavailable',
  DETRACTORS_NO_DATA_MESSAGE: 'Top 10 detractors unavailable',
  DEFAULT_TAB: DISPLAY_TYPE.CONTRIBUTORS,
} as const;
